"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[9575],{

/***/ 9575:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ PressSlider)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper_bundle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1732);



function PressSlider() {
  const settings = {
    pressQuoteSwiper: '[data-press-quote-swiper]',
    pressLogoSwiper: '[data-press-logo-swiper]',
    pausePlayBtn: '[data-press-pause-play]',
    prevSlideBtn: '.press-slide-prev',
    nextSlideBtn: '.press-slide-next',
  }

  ;(function init() {
    initPressSwipers()
  })()

  function initPressSwipers() {
    const logoSwiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A('[data-press-logo-swiper]', {
      slidesPerView: 2.5,
      centeredSlides: true,
      rewind: true,
      initialSlide: 2,
      allowTouchMove: false,
      a11y: {
        slideRole: 'presentation',
      },
      breakpoints: {
        1024: {
          slidesPerView: 6.5,
          initialSlide: 5,
        },
        1920: {
          slidesPerView: 7.5,
        },
      },
    })

    const quoteSwiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A('[data-press-quote-swiper]', {
      slidesPerView: 1,
      centeredSlides: true,
      rewind: true,
      allowTouchMove: false,
      initialSlide: 4,
      spaceBetween: 16,
      navigation: {
        nextEl: '.press-slide-next',
        prevEl: '.press-slide-prev',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      autoplay: {
        delay: 5000,
      },
      controller: {
        control: logoSwiper,
      },
      a11y: {
        slideRole: 'presentation',
      },
    })

    function pausePlaySwiper(e) {
      e.preventDefault()
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pausePlayBtn).hasClass('on') && quoteSwiper.autoplay.running) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pausePlayBtn).removeClass('on')
        quoteSwiper.autoplay.stop()
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pausePlayBtn).addClass('on')
        quoteSwiper.autoplay.start()
      }
    }

    function pauseSwiper(e) {
      e.preventDefault()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pausePlayBtn).removeClass('on')
      quoteSwiper.autoplay.stop()
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pausePlayBtn).on('click', pausePlaySwiper)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.prevSlideBtn).on('click', pauseSwiper)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.nextSlideBtn).on('click', pauseSwiper)
  }
}


/***/ })

}]);